import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'company-events-attendee-tile',
    templateUrl: './company-events-attendee-tile.component.html',
    styleUrls: ['./company-events-attendee-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyEventsAttendeeTileComponent {
  @Input() attendee:any;
  @Input() isEditMode:boolean = false;
  @Input() isRegistered:boolean = false;
  @Output() register:EventEmitter<any> = new EventEmitter<any>();
  @Output() sendOutlookInvite = new EventEmitter();
  @Output() removeAttendee:EventEmitter<any> = new EventEmitter<any>()

  toggleRegister(event:any){
    this.register.emit({id: this.attendee.id, is_registered: event.target.checked, isOnOutlook: this.attendee.isOnOutlook})
  }

  toggleOutlookInvite(event: any){
    this.sendOutlookInvite.emit(this.attendee)
  }

  remove(attendee:any){
    this.removeAttendee.emit(attendee)
  }
}
